import React from "react";
import Routes from "./Routes";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/config';
import { AuthProvider } from './contexts/AuthContext';
import ContactSupportButton from './components/ui/ContactSupportButton';

function App() {
  return (
    <AuthProvider>
      <I18nextProvider i18n={i18n}>
        <Routes />
        <ContactSupportButton />
      </I18nextProvider>
    </AuthProvider>
  );
}

export default App;